import React, { FunctionComponent } from 'react'
import { Icon, Popover, Position, Menu, Button, minorScale } from 'evergreen-ui'

interface MenuPopoverProps {
  onDisableClick: () => void
}

const MenuPopover: FunctionComponent<MenuPopoverProps> = ({ onDisableClick }) => (
  <Popover
    position={Position.BOTTOM_RIGHT}
    content={
      <Menu.Group>
        <Menu.Item intent="danger" onSelect={onDisableClick}>
          Disable
        </Menu.Item>
      </Menu.Group>
    }
  >
    <Button appearance="minimal" display="flex" alignItems="center" height="auto" padding={minorScale(1)}>
      <Icon icon="more" color="muted" size={14} />
    </Button>
  </Popover>
)

export default MenuPopover
